module.exports = __webpack_public_path__ + "img/p8.3cb77578.jpg";